// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFoundTemplate_root__pRLWh","content":"NotFoundTemplate_content__3rVvA"};